"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseModalView = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var __1 = require("..");
var BaseModalView = function (props) { return ((0, jsx_runtime_1.jsxs)(__1.FlexView, __assign({ hAlignContent: "center" }, { children: [(0, jsx_runtime_1.jsx)(__1.Spacer, { height: 1 }), (0, jsx_runtime_1.jsx)(__1.FlexView.Item, __assign({ xs: 4 }, { children: (0, jsx_runtime_1.jsx)(__1.Image, { src: props.imageSrc }) })), (0, jsx_runtime_1.jsx)(__1.Spacer, { height: 1 }), (0, jsx_runtime_1.jsx)(__1.FlexView.Item, __assign({ xs: 12 }, { children: (0, jsx_runtime_1.jsx)(__1.TextFormatter, __assign({ textAlign: "center" }, { children: props.message })) }))] }))); };
exports.BaseModalView = BaseModalView;
//# sourceMappingURL=BaseModalView.js.map